<template>
    <div class="panel panel-default">
        <modal v-model="showModal" title="Alertas">
            <div>
                <ul>
                    <li v-for="(question, i) in alerts" :key="i">
                        {{ question.question }} <br> <strong>R: </strong>
                        <span v-if="question.pivot.answer_radio === 'yes'">Sim</span>
                        <span v-if="question.pivot.answer_radio === 'no'">Não</span>
                        <span v-if="question.pivot.answer_radio === 'do-not-know'">Não Sei</span>
                        <span v-if="question.pivot.answer_text && !question.pivot.answer_radio"> {{ question.pivot.answer_text }}</span>
                        <span v-if="question.pivot.answer_text && question.pivot.answer_radio"> | {{ question.pivot.answer_text }}</span>
                        <hr style="margin: 5px 0 5px 0;">
                    </li>
                </ul>
            </div>

            <div slot="footer">
                <btn type="primary" @click="showModal = false">Ok</btn>
            </div>
        </modal>

        <div class="widget-user-header bg-aqua-active" style="padding: 5px;">
            <div class="row">
                <div class="col-sm-2 col-md-2">

                    <div v-if="alerts.length" @click="showAlerts">                    
                        <span><i style="font-size: 24px; position: absolute; z-index: 999; padding: 2px 0px 0px 2px; cursor: pointer;" class="text-white fa fa-circle" aria-hidden="true"></i></span>
                        <span><i style="font-size: 30px; position: absolute; z-index: 999; cursor: pointer;" class="text-orange fa fa-exclamation-circle" aria-hidden="true"></i></span>
                    </div>
                    

                    <div class="widget-user-image">
                        <webcam-photo-component ref="webcam" :person="patient" url="/file-change-photo-user"></webcam-photo-component>
                    </div>


                </div>
                <div class="col-sm-12 col-md-12">
                    <div class="card-body">
                        <div class='col-sm-2 text-center'>
                            <img id="imagemConvertida" :src="patient.photograph_id ? '/file/' + patient.photograph_id : '/images/no-image.png'" :alt="patient.name" class="img-circle imagemConvertida" width="100" @click="loadCamera"><br>
                            <button type="button" @click="loadCamera" class="btn btn-primary btn-sm" style="margin-top: 5px;"><i class="fa fa-camera"></i> Webcam</button>
                        </div>
                        <div class='col-sm-4'>
                            <div class="form-group">
                                <h3>
                                    <span style="margin-rigth: 10px">{{ patient.code }} {{ patient.contract && ' | '+patient.contract.code }} | {{ patient.name }}</span>
                                </h3>
                                <h4>
                                    <span v-if="patient.phones[0]">{{ patient.phones[0].phone }}</span>
                                    <span v-if="patient.phones[1]"> | {{ patient.phones[1].phone }}</span>
                                    <a v-if="patient.phones.length && patient.phones.find(o => o.phone_type === 'mobile')"
                                       :href="'https://api.whatsapp.com/send?phone=55'+(patient.phones.find(o => o.phone_type === 'mobile')).phone.replace('(','').replace(')','').replace(/\-/g,'')+'&text='" target="_blank">
                                        <img src="/images/whatsapp.png" alt="whatsapp" style="width: 120px;">
                                    </a>
                                </h4>
                                <h5>{{patient.email }}</h5>
                            </div>
                        </div>
                        <div class='col-sm-2'>
                            <h3>Plano(s)</h3>
                            <h5><span v-for="(plan, index) in patient.dental_plans" :key="index">{{ plan.name }} <br></span></h5>
                        </div>
                        <div class='col-sm-4'>
                            <lembrete-form-component :patient="patient"></lembrete-form-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lembreteFormComponent from "./LembreteForm";
    import WebcamPhotoComponent from "./WebcamPhoto";

    export default {
        name: "HeaderInfo",
        components: {WebcamPhotoComponent, lembreteFormComponent },
        props: {
            patient: { Object, required: true },
        },
        data () {
            return {
                showModal: false,
                alerts: []
            }
        },
        methods: {
            loadCamera() {
                this.$refs.webcam.loadCamera();
            },
            showAlerts () {
                this.showModal = true
                console.log(this.alerts)
            }
        },
        created () {
            this.alerts = this.patient.anamnese.questions.filter(o => o.pivot.alert)
        }
    }
</script>
